import { render, staticRenderFns } from "./ServerStatistics.vue?vue&type=template&id=264070de&scoped=true"
import script from "./ServerStatistics.vue?vue&type=script&lang=js"
export * from "./ServerStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264070de",
  null
  
)

export default component.exports